// extracted by mini-css-extract-plugin
export default {"content":"EmployeeCard_content__-Ehkv","employeeCard":"EmployeeCard_employeeCard__UdH28","title":"EmployeeCard_title__ok4Su","button":"EmployeeCard_button__04uxY"};